export { default } from './WelcomeScreen.container';
